module.exports = __webpack_public_path__ + "static/media/ico-add-green.59a8aa9f.svg";